module.exports = __webpack_public_path__ + "static/media/headerLogo--old.e020c265.png";